enum visitTypeDisplayMap {
  PERSONAL_CARE = "Personal Care",
  NURSING_SERVICE = "Nursing Service",
  THERAPEUTIC_SUPPORT = "Therapeutic Support",
  COMPANIONSHIP = "Companionship",
  HOUSEKEEPING = "Housekeeping",
  MEAL_PREPARATION = "Meal Preparation",
  TRANSPORTATION_ASSISTANCE = "Transportation Assistance",
  DIAGNOSTIC = "Diagnostic",
  MONITORING = "Monitoring",
  SPECIALIZED_CARE = "Specialized Care",
  PALLIATIVE_CARE = "Palliative Care",
  MEMORY_CARE = "Memory Care",
  FAMILY_CARE = "Family Care",
  MEDICAL_VISIT = "Medical Visit",
}

export default visitTypeDisplayMap;
